import React, { useCallback } from 'react';

import styled, {
  DefaultTheme,
  Interpolation,
  ThemeProps,
} from 'styled-components';

import { Heading } from '@techstyle/react-components';

import { Component as CloseButton } from '../CloseButton';

import { CartDrawerHeaderTitleMessage } from './CartDrawerHeaderTitleMessage';
import { useDrawerState } from './useDrawerState';

const Header = styled.div<{
  headerWrapperStyling?: Interpolation<ThemeProps<DefaultTheme>>;
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 14px 44px;
  border-bottom: 1px solid ${props => props.theme.colors.gray250};
  ${({ headerWrapperStyling }) => headerWrapperStyling};
`;

const Title = styled(Heading).attrs({
  level: 2,
})<{ headingStyling?: Interpolation<ThemeProps<DefaultTheme>> }>`
  ${({ theme }) => theme.header.variants.h3.textStyles}
  text-align: center;
  ${({ headingStyling }) => headingStyling};
`;

const DrawerCloseButton = styled(CloseButton)<{
  closeButtonStyling?: Interpolation<ThemeProps<DefaultTheme>>;
}>`
  top: 50%;
  right: 0;
  width: 44px;
  height: 44px;
  margin-top: -22px;
  line-height: 1;
  color: ${props => props.theme.colors.subdued};
  ${({ closeButtonStyling }) => closeButtonStyling};
`;

export function CartDrawerHeader({
  headerWrapperStyling,
  closeButtonStyling,
  headingStyling,
}: {
  headerWrapperStyling?: Interpolation<ThemeProps<DefaultTheme>>;
  closeButtonStyling?: Interpolation<ThemeProps<DefaultTheme>>;
  headingStyling?: Interpolation<ThemeProps<DefaultTheme>>;
}) {
  const [, setIsDrawerOpen] = useDrawerState();
  const closeDrawer = useCallback(
    () => setIsDrawerOpen(false),
    [setIsDrawerOpen]
  );
  return (
    <Header headerWrapperStyling={headerWrapperStyling}>
      <Title headingStyling={headingStyling}>
        <CartDrawerHeaderTitleMessage />
      </Title>
      <DrawerCloseButton
        closeButtonStyling={closeButtonStyling}
        onClick={closeDrawer}
        iconSize={12}
      />
    </Header>
  );
}
